/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProgramSession } from '../entities';
// @ts-ignore
import type { ProgramSessionCreateRequest } from '../entities';
// @ts-ignore
import type { ProgramSessionSearchByDateRequest } from '../entities';
// @ts-ignore
import type { ProgramSessionSearchRequest } from '../entities';
// @ts-ignore
import type { ProgramSessionSearchResponse } from '../entities';
// @ts-ignore
import type { ProgramSessionUpdatDateRequest } from '../entities';
// @ts-ignore
import type { ProgramSessionUpdateProgramRequest } from '../entities';
// @ts-ignore
import type { ProgramSessionUpdateProgramResponse } from '../entities';
/**
 * ProgramSessionControllerApi - axios parameter creator
 * @export
 */
export const ProgramSessionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ProgramSessionCreateRequest} programSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create9: async (programSessionCreateRequest: ProgramSessionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programSessionCreateRequest' is not null or undefined
            assertParamExists('create9', 'programSessionCreateRequest', programSessionCreateRequest)
            const localVarPath = `/program/session/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<ProgramSessionCreateRequest>} programSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultiple: async (programSessionCreateRequest: Array<ProgramSessionCreateRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programSessionCreateRequest' is not null or undefined
            assertParamExists('createMultiple', 'programSessionCreateRequest', programSessionCreateRequest)
            const localVarPath = `/program/session/create/multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete9: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delete9', 'id', id)
            const localVarPath = `/program/session/{id}/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByProgramID: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteByProgramID', 'id', id)
            const localVarPath = `/program/session/program/{id}/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProgramSessionCreateRequest} programSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicate2: async (programSessionCreateRequest: ProgramSessionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programSessionCreateRequest' is not null or undefined
            assertParamExists('duplicate2', 'programSessionCreateRequest', programSessionCreateRequest)
            const localVarPath = `/program/session/duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get8: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get8', 'id', id)
            const localVarPath = `/program/session/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch5: async (id: number, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patch5', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patch5', 'body', body)
            const localVarPath = `/program/session/{id}/patch`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProgramSessionSearchRequest} programSessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search7: async (programSessionSearchRequest: ProgramSessionSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programSessionSearchRequest' is not null or undefined
            assertParamExists('search7', 'programSessionSearchRequest', programSessionSearchRequest)
            const localVarPath = `/program/session/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProgramSessionSearchRequest} programSessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWithoutProgram: async (programSessionSearchRequest: ProgramSessionSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programSessionSearchRequest' is not null or undefined
            assertParamExists('searchWithoutProgram', 'programSessionSearchRequest', programSessionSearchRequest)
            const localVarPath = `/program/session/searchWithoutProgram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProgramSessionSearchByDateRequest} programSessionSearchByDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchtSessionBetweenDates: async (programSessionSearchByDateRequest: ProgramSessionSearchByDateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programSessionSearchByDateRequest' is not null or undefined
            assertParamExists('searchtSessionBetweenDates', 'programSessionSearchByDateRequest', programSessionSearchByDateRequest)
            const localVarPath = `/program/session/search/dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSearchByDateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProgramSessionUpdatDateRequest} programSessionUpdatDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update3: async (id: number, programSessionUpdatDateRequest: ProgramSessionUpdatDateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update3', 'id', id)
            // verify required parameter 'programSessionUpdatDateRequest' is not null or undefined
            assertParamExists('update3', 'programSessionUpdatDateRequest', programSessionUpdatDateRequest)
            const localVarPath = `/program/session/{id}/update/date`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionUpdatDateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProgramSessionUpdateProgramRequest} programSessionUpdateProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProgramDetails1: async (id: number, programSessionUpdateProgramRequest: ProgramSessionUpdateProgramRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProgramDetails1', 'id', id)
            // verify required parameter 'programSessionUpdateProgramRequest' is not null or undefined
            assertParamExists('updateProgramDetails1', 'programSessionUpdateProgramRequest', programSessionUpdateProgramRequest)
            const localVarPath = `/program/session/program/{id}/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionUpdateProgramRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails5: async (id: number, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserDetails5', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateUserDetails5', 'body', body)
            const localVarPath = `/program/session/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProgramSessionControllerApi - functional programming interface
 * @export
 */
export const ProgramSessionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProgramSessionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ProgramSessionCreateRequest} programSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create9(programSessionCreateRequest: ProgramSessionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create9(programSessionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.create9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<ProgramSessionCreateRequest>} programSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMultiple(programSessionCreateRequest: Array<ProgramSessionCreateRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProgramSession>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMultiple(programSessionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.createMultiple']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete9(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete9(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.delete9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByProgramID(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByProgramID(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.deleteByProgramID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProgramSessionCreateRequest} programSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicate2(programSessionCreateRequest: ProgramSessionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicate2(programSessionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.duplicate2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get8(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get8(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.get8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patch5(id: number, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patch5(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.patch5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProgramSessionSearchRequest} programSessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search7(programSessionSearchRequest: ProgramSessionSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search7(programSessionSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.search7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProgramSessionSearchRequest} programSessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchWithoutProgram(programSessionSearchRequest: ProgramSessionSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchWithoutProgram(programSessionSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.searchWithoutProgram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProgramSessionSearchByDateRequest} programSessionSearchByDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchtSessionBetweenDates(programSessionSearchByDateRequest: ProgramSessionSearchByDateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchtSessionBetweenDates(programSessionSearchByDateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.searchtSessionBetweenDates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProgramSessionUpdatDateRequest} programSessionUpdatDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update3(id: number, programSessionUpdatDateRequest: ProgramSessionUpdatDateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update3(id, programSessionUpdatDateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.update3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProgramSessionUpdateProgramRequest} programSessionUpdateProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProgramDetails1(id: number, programSessionUpdateProgramRequest: ProgramSessionUpdateProgramRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProgramSessionUpdateProgramResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProgramDetails1(id, programSessionUpdateProgramRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.updateProgramDetails1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserDetails5(id: number, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: boolean; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDetails5(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionControllerApi.updateUserDetails5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProgramSessionControllerApi - factory interface
 * @export
 */
export const ProgramSessionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProgramSessionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ProgramSessionCreateRequest} programSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create9(programSessionCreateRequest: ProgramSessionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSession> {
            return localVarFp.create9(programSessionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<ProgramSessionCreateRequest>} programSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultiple(programSessionCreateRequest: Array<ProgramSessionCreateRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProgramSession>> {
            return localVarFp.createMultiple(programSessionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete9(id: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.delete9(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByProgramID(id: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.deleteByProgramID(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProgramSessionCreateRequest} programSessionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicate2(programSessionCreateRequest: ProgramSessionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSession> {
            return localVarFp.duplicate2(programSessionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get8(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSession> {
            return localVarFp.get8(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch5(id: number, body: object, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSession> {
            return localVarFp.patch5(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProgramSessionSearchRequest} programSessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search7(programSessionSearchRequest: ProgramSessionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSearchResponse> {
            return localVarFp.search7(programSessionSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProgramSessionSearchRequest} programSessionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWithoutProgram(programSessionSearchRequest: ProgramSessionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSearchResponse> {
            return localVarFp.searchWithoutProgram(programSessionSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProgramSessionSearchByDateRequest} programSessionSearchByDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchtSessionBetweenDates(programSessionSearchByDateRequest: ProgramSessionSearchByDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSearchResponse> {
            return localVarFp.searchtSessionBetweenDates(programSessionSearchByDateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProgramSessionUpdatDateRequest} programSessionUpdatDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update3(id: number, programSessionUpdatDateRequest: ProgramSessionUpdatDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSession> {
            return localVarFp.update3(id, programSessionUpdatDateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProgramSessionUpdateProgramRequest} programSessionUpdateProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProgramDetails1(id: number, programSessionUpdateProgramRequest: ProgramSessionUpdateProgramRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProgramSessionUpdateProgramResponse>> {
            return localVarFp.updateProgramDetails1(id, programSessionUpdateProgramRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails5(id: number, body: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: boolean; }>> {
            return localVarFp.updateUserDetails5(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProgramSessionControllerApi - object-oriented interface
 * @export
 * @class ProgramSessionControllerApi
 * @extends {BaseAPI}
 */
export class ProgramSessionControllerApi extends BaseAPI {
    /**
     * 
     * @param {ProgramSessionCreateRequest} programSessionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public create9(programSessionCreateRequest: ProgramSessionCreateRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).create9(programSessionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<ProgramSessionCreateRequest>} programSessionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public createMultiple(programSessionCreateRequest: Array<ProgramSessionCreateRequest>, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).createMultiple(programSessionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public delete9(id: number, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).delete9(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public deleteByProgramID(id: number, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).deleteByProgramID(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProgramSessionCreateRequest} programSessionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public duplicate2(programSessionCreateRequest: ProgramSessionCreateRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).duplicate2(programSessionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public get8(id: number, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).get8(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public patch5(id: number, body: object, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).patch5(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProgramSessionSearchRequest} programSessionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public search7(programSessionSearchRequest: ProgramSessionSearchRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).search7(programSessionSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProgramSessionSearchRequest} programSessionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public searchWithoutProgram(programSessionSearchRequest: ProgramSessionSearchRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).searchWithoutProgram(programSessionSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProgramSessionSearchByDateRequest} programSessionSearchByDateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public searchtSessionBetweenDates(programSessionSearchByDateRequest: ProgramSessionSearchByDateRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).searchtSessionBetweenDates(programSessionSearchByDateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProgramSessionUpdatDateRequest} programSessionUpdatDateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public update3(id: number, programSessionUpdatDateRequest: ProgramSessionUpdatDateRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).update3(id, programSessionUpdatDateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProgramSessionUpdateProgramRequest} programSessionUpdateProgramRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public updateProgramDetails1(id: number, programSessionUpdateProgramRequest: ProgramSessionUpdateProgramRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).updateProgramDetails1(id, programSessionUpdateProgramRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionControllerApi
     */
    public updateUserDetails5(id: number, body: string, options?: RawAxiosRequestConfig) {
        return ProgramSessionControllerApiFp(this.configuration).updateUserDetails5(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}

